import { mapDTO } from '@twistezo/ts-dto-mapper'
import { omit } from 'lodash'

import { Ability } from 'providers/casl'
import { fieldsToOmit } from 'providers/tanstack-query/utils'
import { minutesToMilliseconds } from 'utils/number'
import { Schema } from '../../../Sections/MultiAnchorSection/schema'
import { Variables } from './types'

type From = Schema
type To = Omit<Variables, 'workspaceId'>

export const toDTO = (from: From, ability: Ability): To =>
  mapDTO<From, To>({ from }).transform(
    ({
      counterStyle,
      customStyling,
      displayAfterUserInteraction,
      frequencyCappingEnabled,
      fullWidthMode,
      impressionLimit,
      showCloseButton,
      singleAdViewTime,
      timeWindow,
    }: From): To => {
      const constantFields: Pick<
        To,
        | 'counterStyle'
        | 'customStyling'
        | 'displayAfterUserInteractionEnabled'
        | 'fullWidthModeEnabled'
        | 'showCloseButtonEnabled'
        | 'singleAdViewTime'
      > = {
        counterStyle,
        customStyling: JSON.parse(customStyling),
        displayAfterUserInteractionEnabled: displayAfterUserInteraction,
        fullWidthModeEnabled: fullWidthMode,
        showCloseButtonEnabled: showCloseButton,
        singleAdViewTime,
      }

      const variableFields: Pick<To, 'frequencyCappingEnabled' | 'impressionLimit' | 'timeWindow'> =
        {
          frequencyCappingEnabled,
          impressionLimit,
          ...(timeWindow !== undefined ? { timeWindow: minutesToMilliseconds(timeWindow) } : {}),
        }

      return {
        ...constantFields,
        ...omit(
          variableFields,
          fieldsToOmit<To>({
            frequencyCappingEnabled: ability.cannot('update', 'GlobalSetupField-frequencyCapping'),
            impressionLimit: ability.cannot('update', 'GlobalSetupField-frequencyCapping'),
            timeWindow: ability.cannot('update', 'GlobalSetupField-frequencyCapping'),
          }),
        ),
      }
    },
  )
